import { useState, useEffect, useCallback } from 'react';
import { CONSTANTS } from '../data.js';

export const useNotifications = () => {
  const [notification, setNotification] = useState(null);
  const [notificationType, setNotificationType] = useState('info');

  const showNotification = useCallback((message, type = 'info') => {
    setNotification(message);
    setNotificationType(type);
  }, []);

  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => setNotification(null), CONSTANTS.NOTIFICATION_TIMEOUT);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  return {
    notification,
    notificationType,
    showNotification
  };
};
